
import {
  defineComponent,
  onMounted,
  ref,
  reactive,
  toRefs,
  watch,
  inject,
  nextTick,
} from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  props: {
    left: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    // store temp tabs
    const tabs = reactive({ tabs: [], titles: {} as Record<any, any> });
    tabs.tabs = store.getters.assnUserTabs;
    tabs.titles = store.getters.assnUserTitles;
    // active
    const activeKey = ref<string>("");
    // tabs action
    const onEdit = (targetKey: string | MouseEvent, action: string) => {
      if (action === "remove") {
        remove(targetKey as string);
      }
    };
    const onChange = (targetKey: string) => {
      router.push({ path: targetKey });
    };
    // common action
    const remove = (targetKey: string) => {
      let lastIndex = 0;
      tabs.tabs.forEach((tab, i) => {
        if (tab["path"] === targetKey) {
          lastIndex = i - 1 ? i - 1 : 0;
        }
      });
      tabs.tabs = tabs.tabs.filter((tab) => tab["path"] !== targetKey);
      setTabs();
      if (tabs.tabs.length && activeKey.value === targetKey) {
        activeKey.value = tabs.tabs[lastIndex]["path"];
        router.push({ path: activeKey.value });
      }
    };
    const setTabs = () => {
      store.commit("setDatas", ["assnUserTabs", tabs.tabs]);
      const assnUserPages: Record<string, any> = [];
      tabs.tabs.forEach((val: any) => {
        assnUserPages.push(val.name);
      });
      store.commit("setDatas", ["assnUserPages", assnUserPages]);
    };
    const routeChange = (path: string) => {
      const dynamicKey =
        (route.name as string) + Object.values(route.params).join("");
      const title =
        route.meta.dynamic == true ? tabs.titles[dynamicKey] : route.meta.title;
      const tab = {
        name: route.name,
        path: path,
        title: title,
        closable: route.meta.closable,
      };
      const isExist = tabs.tabs.some(
        (item) => item["name"] == route.name && item["path"] == path
      );
      activeKey.value = path;
      if (!isExist && route.meta.keepAlive !== false) {
        tabs.tabs.push(tab as never);
        setTabs();
      }
    };
    // route watch
    watch(
      () => route.path,
      (rp) => {
        routeChange(rp as string);
      }
    );
    // cMenu
    const cMenu = [
      { name: "重新加载", icon: "menu-open", action: "reload" },
      { name: "关闭左边", icon: "menu-open", action: "closeL" },
      { name: "关闭右边", icon: "menu-open", action: "closeR" },
      { name: "关闭其他", icon: "menu-open", action: "closeO" },
    ];
    const fiterStr = (s1: string, s2: string) => {
      const l = s1.length > s2.length ? s2.length : s1.length;
      let i = 0;
      while (i < l) {
        if (s1[i] !== s2[i]) {
          break;
        }
        i++;
      }
      return s1.substr(0, i);
    };
    const openContextMenu = (e: any, tab: any) => {
      emitContext(e, { name: "tab-menu", tab });
    };
    const emitContext = inject("emitContext") as (
      event: Event,
      dataId: Record<string, unknown>
    ) => void;
    const cMenuClick = (e: any, action: string) => {
      const tab = e.tab;
      const clickIndex = tabs.tabs.indexOf(tab as never);
      const routeIndex = tabs.tabs.findIndex(
        (tab) => tab["name"] === route.name && tab["path"] === route.path
      );
      // reload
      if (action === "reload") {
        const routers = router.getRoutes();
        tabs.tabs.forEach((item: Record<any, any>, idx: number) => {
          const routeItem =
            routers.find((r) => {
              return item.name === r.name;
            }) || routers[0];
          const commonStr = fiterStr(routeItem.path, item.path);
          const dynamicKey = item.name + item.path.replace(commonStr, "");
          const title =
            routeItem.meta.dynamic == true
              ? tabs.titles[dynamicKey]
              : routeItem.meta.title;
          (tabs.tabs[idx] as any).title = title;
        });
        setTabs();
        nextTick(() => {
          // window.location.reload();
        });
      }
      // close left
      else if (action === "closeL") {
        if (clickIndex > routeIndex) {
          router.replace(tab);
        }
        const keys: any = [];
        for (let i = 0; i < clickIndex; i++) {
          if (
            tabs.tabs[i]["closable"] === undefined ||
            tabs.tabs[i]["closable"] === true
          ) {
            keys.push(tabs.tabs[i]["path"]);
          }
        }
        keys.forEach((val: string) => {
          remove(val);
        });
      }
      // close right
      else if (action === "closeR") {
        if (clickIndex < routeIndex) {
          router.replace(tab);
        }
        const keys: any = [];
        for (let i = clickIndex + 1; i < tabs.tabs.length; i++) {
          if (
            tabs.tabs[i]["closable"] === undefined ||
            tabs.tabs[i]["closable"] === true
          ) {
            keys.push(tabs.tabs[i]["path"]);
          }
        }
        keys.forEach((val: string) => {
          remove(val);
        });
      }
      // close other
      else if (action === "closeO") {
        if (clickIndex !== routeIndex) {
          router.replace(tab);
        }
        const keys: any = [];
        for (let i = 0; i < tabs.tabs.length; i++) {
          if (
            (tabs.tabs[i]["closable"] === undefined ||
              tabs.tabs[i]["closable"] === true) &&
            clickIndex !== i
          ) {
            keys.push(tabs.tabs[i]["path"]);
          }
        }
        keys.forEach((val: string) => {
          remove(val);
        });
      }
    };
    onMounted(() => {
      routeChange(route.path as string);
    });
    return {
      ...toRefs(tabs),
      activeKey,
      onEdit,
      onChange,
      cMenu,
      openContextMenu,
      cMenuClick,
    };
  },
});
